import { combineReducers } from 'redux';

import { reducer as form } from './form/state';
import requestTasks from './requestTasks/reducers';

const bulkRequestReducer = combineReducers({
  form,
  requestTasks,
});

export default bulkRequestReducer;

export type BulkRequestState = ReturnType<typeof bulkRequestReducer>;
